import { Component } from 'react';
import PropTypes from 'prop-types';
import { isCrmPropertiesField, shouldUseJsonField } from '../../utils/typeUtils';
import { getIsPropertyRequired, getModelName, getSchemaType, retrieveSchema } from '../../utils/schemaUtils';
import { getParamRowId } from '../../utils/idUtils';
import DescriptorBlock from './shared/DescriptorBlock';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import JSONInput from '../inputs/JSONInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class JsonField extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const schemaType = getSchemaType(this.props.schema);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.isCrmPropertiesField = isCrmPropertiesField( /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.schema, schemaType, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.idSchema, /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.name);
  }
  getValueOrExample() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      formData,
      schema,
      idSchema
    } = this.props;
    let valueOrExample = {};
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    if (this.isCrmPropertiesField) {
      valueOrExample = (formData || {}).properties;
    } else if (shouldUseJsonField(schema, idSchema.$id)) {
      valueOrExample = formData || {};
    }
    return valueOrExample;
  }
  getLabel() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      label,
      schema
    } = this.props;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    if (this.isCrmPropertiesField) {
      return 'properties';
    } else if (label) {
      return label;
    }
    return getModelName(schema);
  }
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      collapsed,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      isAdditionalProperty,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onChange,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schemaGroup
    } = this.props;
    const {
      definitions,
      formContext
    } = registry;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    const {
      description
    } = schema;
    return /*#__PURE__*/_jsx("div", {
      className: "params-row",
      "data-test-id": `schema-field-${getParamRowId(idSchema.$id)}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "params-pair",
        children: [/*#__PURE__*/_jsx(DescriptorBlock
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
          description: description,
          id: idSchema.$id,
          label: this.getLabel(),
          required: required || getIsPropertyRequired(schema, this.getLabel()),
          schema: schema,
          schemaGroup: schemaGroup,
          schemaTypeI18nKey: "types.object"
        }), /*#__PURE__*/_jsx("div", {
          className: "params-content",
          children: /*#__PURE__*/_jsx(CollapseFieldWrapper, {
            collapsed: collapsed,
            formData: /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
            this.isCrmPropertiesField ? (formData || {}).properties : formData || {},
            isAdditionalProperty: isAdditionalProperty,
            children: /*#__PURE__*/_jsx(JSONInput
            /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
              disabled: disabled,
              formContext: formContext,
              id: idSchema && idSchema.$id,
              onChange: onChange,
              readOnly: readOnly,
              required: required || getIsPropertyRequired(schema, this.getLabel()),
              schema: schema,
              value: this.getValueOrExample()
            })
          })
        })]
      })
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
JsonField.propTypes = {
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};